import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsWalkNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M19.532 9a9.5 9.5 0 015.352 1.65l8.849 6.034 9.75 4.334A7.605 7.605 0 0148 27.968c0 .048-.001.128-.012.227-.046.419-.348 2.397-2.13 4.28-1.816 1.92-4.966 3.526-10.294 3.526H4.682a4.682 4.682 0 01-3.31-7.994l.067-.068c.36-.359.561-.845.561-1.353V14.073A3.073 3.073 0 015.073 11c1.34 0 2.614.578 3.496 1.586L10.68 15h4.238l-1.342-4.026A1.5 1.5 0 0115 9zm-2.45 3l2 6H9.318l-3.008-3.438A1.645 1.645 0 005.073 14a.073.073 0 00-.073.073v12.513c0 .139-.006.277-.017.414H36.5c1.381 0 2.126-.62 3.253-1.621l.06-.053c.606-.54 1.324-1.178 2.265-1.65l-8.532-3.791-2.13 3.195-2.496-1.664 2.008-3.013-2.333-1.591-2.179 3.268-2.496-1.664 2.196-3.294-2.922-1.992A6.5 6.5 0 0019.532 12zM3.62 30l-.06.06-.067.069A1.682 1.682 0 004.682 33h30.882c4.694 0 6.984-1.39 8.115-2.586 1.058-1.118 1.283-2.254 1.32-2.5a4.599 4.599 0 00-.43-1.892c-1.118.118-1.818.707-2.822 1.6l-.06.052C40.57 28.667 39.072 30 36.5 30z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWalkNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsWalkNormalLarge;
